import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { AuthProvider } from 'authorization/providers/auth/auth-provider';
import { MessageIcon } from '../../messages/pages/message/message.page.icons';
import { MessagePageController } from '../../messages/providers/message-page-controller';

/**
* CanActivate method implementation, returning true if the page can
* be accessed or a URL tree if a redirection has to be done.
* Will return true only if the client has signed into the application already
* @param next
* @param state
*/
export const AuthGuard: CanActivateFn =
    (
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot
    ) =>
    {
        let auth = inject(AuthProvider);
        let messagePageController = inject(MessagePageController);
        // checks if user session exists
        let userIdentity = auth.getUserIdentity();
        if (userIdentity)
        {
            return true;
        } else
        {
            return messagePageController
                .goToMessagePage
                ({
                    icon: MessageIcon.GENERIC,
                    messageExclaimation: `Hi there!`,
                    messageTagline: `You need to sign in!`,
                    messageDescription: `You need to sign in order to see this page!`,
                });
        }
    }